import { render, staticRenderFns } from "./chip.vue?vue&type=template&id=7ba87fc4&"
import script from "./chip.vue?vue&type=script&lang=js&"
export * from "./chip.vue?vue&type=script&lang=js&"
import style0 from "./chip.vue?vue&type=style&index=0&id=7ba87fc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports